import React, { Component } from 'react';
import '../../Style/login.css';
import { connect } from 'react-redux';
import * as repositoryActions from '../../Store/Actions/repositoryActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class SidebarItem extends Component {
  constructor() {
    super();
    this.state = {
      expended:false,
    };
  }

  onClickMenuItem = (e)=>{
    e.preventDefault();
    this.props.updateActiveMenu(this.props.View);
    this.props.updateActiveURI(this.props.URI);
    this.props.updateActiveSubMenu(null);
  }

  onClickSubMenuItem = (e)=>{
    this.props.updateActiveMenu(this.props.View);
    this.props.updateActiveURI(this.props.URI);
    this.props.updateActiveSubMenu(e);
    this.props.updateActiveData({item:this.props.View,subitem:e});
  }

  onClickExpend = (e)=>{
    this.setState({expended:!this.state.expended});
  }
  


  render() {
    var SubItems = this.props.SubItems.map((item,i) => 
      <li key={i} onClick={this.onClickSubMenuItem.bind(this,item)} className={this.props.activeSubMenu===item?"active":""}><span>{item}</span> <FontAwesomeIcon onClick={this.onClickExpend} icon="caret-right"/></li>
    );

    return (
      <div className={this.props.activeMenu===this.props.View?"sidebar-item active":"sidebar-item"}>
        <div className={this.props.activeMenu===this.props.View?"menu active":"menu"}><span onClick={this.onClickMenuItem}>{this.props.View}</span> <FontAwesomeIcon onClick={this.onClickExpend} icon={(this.props.activeMenu===this.props.View || this.state.expended)?"minus":"plus"}/></div>
        <ul className={(this.props.activeMenu===this.props.View || this.state.expended)?"show":"hide"}>
          {SubItems}
        </ul>
       
      </div>
    );
  }
}

const mapStateToProps = (state) => {    
  return {  
    activeMenu : state.appReducer.activeMenu,
    activeSubMenu : state.appReducer.activeSubMenu,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveMenu: (uri) => dispatch(repositoryActions.updateActiveMenu(uri)),
    updateActiveURI: (uri) => dispatch(repositoryActions.updateActiveURI(uri)),
    updateActiveSubMenu:(uri) => dispatch(repositoryActions.updateActiveSubMenu(uri)),
    updateActiveData:(uri) => dispatch(repositoryActions.updateActiveData(uri)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(SidebarItem);
